












































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'
import { IConvoMergeInfo, IPersonBase } from '@/api/types/response.types'

/* API */
import ConversationsAPI from '@/api/modules/convos.api'

export default Vue.extend({
  name: 'BulkMergeConversationsModal',
  props: {
    mailboxId: {
      type: Number,
      required: true,
    },
    selectedConvoIds: {
      type: Array as () => number[],
      default: (): number[] => [],
    },
  },
  data() {
    return {
      EEntities,
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      userAcceptanceClicked: false,

      convoMergeInfo: {} as IConvoMergeInfo,
    }
  },
  computed: {
    subtitle(): string {
      if (this.isLoading) {
        return ''
      }
      return `Comments, replies, tags, and linked tasks will be merged into the oldest conversation, 
          #${this.convoMergeInfo.consolidatedConvo.refNumber}.`
    },
    potentialCustomers(): IPersonBase[] {
      const result = this.convoMergeInfo.listMergingConvos.map(c => c.customer)
      result.push(this.convoMergeInfo.consolidatedConvo.customer)

      const uniqueResults = result.filter(
        (value, index, self) =>
          self.findIndex(item => item.id === value.id) === index,
      )

      const sortedUniqueResults = uniqueResults.sort(
        (a: IPersonBase, b: IPersonBase) => {
          if (a.name < b.name) {
            return -1
          }
          if (a.name > b.name) {
            return 1
          }
          return 0
        },
      )

      return sortedUniqueResults
    },
  },
  watch: {},
  async created() {
    this.isLoading = true
    this.convoMergeInfo = await ConversationsAPI.get_MergePreview(
      this.mailboxId,
      TextAssistant.convertNumberArrayToStringList(this.selectedConvoIds),
    )
    this.isLoading = false
  },
  methods: {
    async handleMerge() {
      this.isSubmitting = true
      let submitSucceeded = false
      try {
        const response = await ConversationsAPI.put_Merge(
          this.mailboxId,
          this.selectedConvoIds,
        )
        this.$messaging.showSuccess(response.message)
        submitSucceeded = true
      } catch (error) {
        this.$error.emit(error, true)
      }

      this.isSubmitting = false
      // Do update...
      if (submitSucceeded) {
        this.$emit('edit-completed')
      }
    },
  },
})
